export type CookiesConsentTranslationsKeys = {
  cookiesConsentTitle: string;
  cookiesConsentDescription: string;
  cookiesConsentManageDescription: string;
  cookiePolicy: string;
  cookiePolicyLearnMore: string;
  cookiesConsentAcceptAll: string;
  cookiesConsentAcceptEssentials: string;
  cookiesConsentManage: string;
  cookiesConsentConfirmPreferences: string;
  cookiesConsentManageLabel: string;
  cookiesConsentPerformanceCookies: string;
  cookiesConsentAdvertisementCookies: string;
  cookiesConsentEssentialCookies: string;
  cookiesConsentAlwaysActive: string;
  cookies: string;
  cookiesConsentAdvertisementCookiesDescription: string;
  cookiesConsentPerformanceCookiesDescription: string;
};

export const initialCookiesConsentTranslations: CookiesConsentTranslationsKeys =
  {
    cookiesConsentAcceptAll: 'cookies_consent_accept_all',
    cookiesConsentAcceptEssentials: 'cookie_consent_accept_essentials',
    cookiesConsentAlwaysActive: 'cookie_consent_always_active',
    cookiesConsentAdvertisementCookies: 'cookie_consent_advertisement_cookies',
    cookiesConsentConfirmPreferences: 'cookie_consent_confirm_preferences',
    cookiesConsentDescription: 'cookie_consent_description',
    cookiesConsentEssentialCookies: 'cookie_consent_essential_cookies',
    cookiesConsentManage: 'cookie_consent_manage',
    cookiesConsentManageDescription: 'cookie_consent_manage_description',
    cookiesConsentManageLabel: 'cookie_consent_manage_label',
    cookiesConsentPerformanceCookies: 'cookie_consent_performance_cookies',
    cookiesConsentTitle: 'cookie_consent_title',
    cookiePolicy: 'cookie_policy',
    cookiePolicyLearnMore: 'cookie_policy_learn_more',
    cookiesConsentPerformanceCookiesDescription:
      'cookie_consent_performance_cookies_description',
    cookiesConsentAdvertisementCookiesDescription:
      'cookie_consent_advertisement_cookies_description',
    cookies: 'cookies',
  };

export const getCookiesConsentTranslations = (
  t: (translationKey: keyof CookiesConsentTranslationsKeys) => string,
): CookiesConsentTranslationsKeys => {
  return Object.entries(initialCookiesConsentTranslations).reduce(
    (acc, [key, value]) => {
      acc[key as keyof CookiesConsentTranslationsKeys] = t(
        value as keyof CookiesConsentTranslationsKeys,
      );

      return acc;
    },
    {} as CookiesConsentTranslationsKeys,
  );
};
